import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import Loading from '../Loading/Loading';
import { RootState } from '@/store/store';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
	const { isAuth, initialized } = useSelector((state: RootState) => state.auth);

	if (!initialized) return <Loading />;

	if (!isAuth) {
		return <Navigate to='/authenticate' replace />;
	}

	return children;
};

export default ProtectedRoute;
